import React, { memo } from 'react';

import { connect } from 'react-redux';

import dynamic from 'next/dynamic';

// VDP Containers
import { useFeatures } from '@atc/features';

import { vdpResultsDuck } from '@/ducks/vdp';

import MyWalletContainer from '@/containers/MyWalletContainer';

import BuildAndPriceHeaderContainer from './BuildAndPriceHeaderContainer';

const BuildAndPriceContainer = dynamic(() => import(
    /* webpackChunkName: "BuildAndPriceContainer" */
    '@/containers/bap/BuildAndPriceContainer'
), { ssr: true });

// Global containers

export const BuildAndPricePageContainer = memo(() => {
    const {
        my_wallet: [enableMyWallet],
    } = useFeatures([
        'my_wallet',
    ]);

    return (
        <>
            <BuildAndPriceHeaderContainer />
            <main aria-labelledby="build-and-price-heading">
                <BuildAndPriceContainer />
            </main>
            {enableMyWallet && <MyWalletContainer />}
        </>
    );
});

const mapStateToProps = (state) => {
    const { query } = state;
    // TODO need to create bapResutlsDuck?
    const listing = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return {
        query,
        listingId: listing.id,
    };
};

export default connect(mapStateToProps)(BuildAndPricePageContainer);
